import Enum from '@/modules/core/app/helpers/Enum';
import { DocumentSubType } from '/@/modules/document/enums/DocumentSubType';

export class ExtractionType extends Enum {
  static STEP_895621_WILL_EXECUTORS: string = 'step_895621_will_executors';
  static WILL_UNIQUE_CONTACTS: string = 'will_unique_contacts';
  static WILL_EXECUTORS: string = 'will_executors';
  static WILL_RESIDUAL_BENEFICIARIES: string = 'will_residual_beneficiaries';
  static WILL_SPECIFIC_BENEFICIARIES: string = 'will_specific_beneficiaries';
  static WILL_EXTRACTION: string = 'will_extraction';
  static POA_PERSONAL_CARE_EXTRACTION: string = 'poa_personal_care_extraction';
  static POA_PROPERTY_EXTRACTION: string = 'poa_property_extraction';

  static fromDocumentSubType(subType: string): string {
    switch (subType) {
      case DocumentSubType.ESTATE_WILL.key:
        return ExtractionType.WILL_EXTRACTION;
      case DocumentSubType.ESTATE_POWER_OF_ATTORNEY_PERSONAL_CARE.key:
        return ExtractionType.POA_PERSONAL_CARE_EXTRACTION;
      case DocumentSubType.ESTATE_POWER_OF_ATTORNEY_PROPERTY.key:
        return ExtractionType.POA_PROPERTY_EXTRACTION;
      default:
        return ExtractionType.WILL_EXTRACTION;
    }
  }

  static getWillExtractionTypes(): ExtractionType[] {
    return [
      ExtractionType.WILL_EXECUTORS,
      ExtractionType.WILL_RESIDUAL_BENEFICIARIES,
      ExtractionType.WILL_SPECIFIC_BENEFICIARIES
    ];
  }
}
